import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REGISTRATION_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import growl from "../../lib/growl/growl.js";
import { authAction, registrationAction } from "../actions";

const request = data => {
    return fetch(`${ url }/registration`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRegistration(args) {
    const registration_form = yield select(state => state.registration_form);
    const auth_form = yield select(state => state.auth_form);
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('name', args.data?.name);
        formData.append('phone', args.data?.phone);
        formData.append('email', args.data?.email);
        formData.append('birthday', args.data?.birthday);
        formData.append('gender', args.data?.gender);
        formData.append('password', args.data?.password);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            // Закрываем форму регистрации
            yield put(registrationAction({
                ...registration_form,
                open: false
            }));

            // Открываем форму авторизации
            yield put(authAction({
                ...auth_form,
                open: true
            }));

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherRegistration() {
    yield takeLatest(REGISTRATION_SAGA, workerRegistration);
}